class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );

    this.assignEventsToChangeQuantity();
  }

  open() {

    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  renderCartContent() {
    fetch('/', {
      method: 'GET',
      headers: {
        'Content-Type': 'text/html',
      },
    })
    .then(response => response.text())
    .then(html => {
      let tempDiv = document.createElement('div');
      tempDiv.innerHTML = html;
  
      let cartRefreshElement = tempDiv.querySelector('#cart-refresh');
      if (cartRefreshElement) {
        document.getElementById('cart-refresh').innerHTML = cartRefreshElement.innerHTML;
        updateIconQuantity()
        this.open();
        this.assignEventsToChangeQuantity();

      } else {
        console.error('not found ID #cart-refresh.');
      }
    })
    .catch(error => console.error('Error in cart:', error));
  }
  
  async updateQuantityItem(id, quantity){
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        updates: {
          [id]: quantity,
        },
      }),
    })
      .then((response) => response.json())
      .then(() => {
        this.renderCartContent();
        this.assignEventsToChangeQuantity();
      });
  }

  changeQuantity(evt){
    const input = evt.target.closest('.cart-notification__item').querySelector('.cart-notification__quantity-input');
    const id = input.getAttribute('reference');
    const quantity = parseInt(input.value);
    this.updateQuantityItem(id, quantity);
  }

  changeQuantityFromButton(evt) {
    const button = evt.target;
    const direction = button.getAttribute('data-direction');

    const input = button.parentElement.querySelector('.cart-notification__quantity-input');
    const currentQuantity = parseInt(input.value);
    const newQuantity = direction === 'plus' ? currentQuantity + 1 : currentQuantity - 1;
    input.value = newQuantity;

    this.changeQuantity(evt);
  }

  removeItem(evt){
    evt.preventDefault();
    const link = evt.target;
    const id = link.getAttribute('reference');
    this.updateQuantityItem(id, 0);
  }

  assignEventsToChangeQuantity(){
    const quantityButtons = this.notification.querySelectorAll('.cart-notification__quantity-button');
    quantityButtons.forEach((button) => button.addEventListener('click', (e) => this.changeQuantityFromButton(e)));
    
    const quantityInputs = this.notification.querySelectorAll('.cart-notification__quantity-input');
    quantityInputs.forEach((button) => button.addEventListener('change', (e) => this.changeQuantity(e)));

    const removeLink = this.notification.querySelectorAll('.remove-item')
    removeLink.forEach((link) => link.addEventListener('click', (e) => this.removeItem(e)));
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    // const HTMLNotification = document.querySelector('.cart-p-info');
    // HTMLNotification.innerHTML = '';
    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    if (this.header) this.header.reveal();
    this.renderCartContent();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
